import React, { useEffect, useState } from 'react';
import API from '../services/api';
import '../styles/PaidDebts.css'; // Import CSS

// const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function PaidDebts() {
  const [debts, setDebts] = useState([]);

  const fetchPaidDebts = async () => {
    const res = await API.get('/debts/paid');
    setDebts(res.data);
  };

  useEffect(() => {
    fetchPaidDebts();
  }, []);

  return (
    <div className="paid-container">
      <h2 className="paid-title">📋 Daftar Hutang yang Lunas</h2>
      {debts.length === 0 ? (
        <p className="no-debt">Tidak ada hutang yang lunas.</p>
      ) : (
        <ul className="debt-list">
          {debts.map(d => (
            <li key={d.id} className="debt-item">
              <div className="debt-name">{d.debtor_name}</div>
              <div className="debt-amount">Rp {parseInt(d.amount).toLocaleString('id-ID')}</div>
              <div className="debt-dates">
                <small>Tanggal Hutang: {new Date(d.date).toLocaleDateString('id-ID')}</small><br />
                <small>Tanggal Lunas: {d.paid_at ? new Date(d.paid_at).toLocaleDateString('id-ID') : '-'}</small>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
